// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"2755e314","349":"159ec679","422":"e52fd0b5","725":"034089a9"}[chunkId] + ".chunk.js";
};